import { createSelector } from 'reselect';

import { StateType } from '@redux/reducers';

const getBillingState = ({ appBillings }: StateType) => appBillings;

export const billingAppDetailsSelector = createSelector(
  [getBillingState],
  ({ billingDetails }) => billingDetails
);
export const billingAppCreditsSelector = createSelector(
  [getBillingState],
  ({ billingCredits }) => billingCredits
);
export const billingAppAddressSelector = createSelector(
  [getBillingState],
  ({ billingAddress }) => billingAddress
);